import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

// "Delete {staff}?" confirmation dialog — actually deactivates (soft-delete),
// account can be reactivated later.
export default function DeleteStaffDialog({ target, onOpenChange, deleting, onConfirm }) {
  return (
    <Dialog open={!!target} onOpenChange={onOpenChange}>
      <DialogContent data-testid="delete-staff-modal">
        <DialogHeader>
          <DialogTitle>Delete {target?.name}?</DialogTitle>
          <DialogDescription>
            This will deactivate their account — they will no longer be able to log in. Their historical actions
            remain on record and you can reactivate this account anytime.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" data-testid="delete-staff-cancel-btn" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="delete-staff-confirm-btn" className="bg-red-600 hover:bg-red-700" disabled={deleting} onClick={onConfirm}>
            {deleting ? "Deleting..." : "Delete Staff"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
